(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('p2WebpageEdit', {
        templateUrl: 'views/components/views/p2WebpageEdit/p2WebpageEdit.template.html?v=' + module.version,
        controllerAs: 'vm',
        bindings: {
            p2WebpageKeyno: '<?',
            onSave: '&'
        },
        controller: ['$stateParams', 'stateService', 'p2WebpageEditService', 'layoutService', function ($stateParams, stateService, p2WebpageEditService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let p2WebpageKeyno = vm?.p2WebpageKeyno ?? $stateParams.p2_webpage_keyno;
            let tabletSize = layoutService.getMediaQueries().tablet;
            
            vm.model = {
                tabletSize: tabletSize,
                edit: {},
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALL
            
            let loadEdit = function () {
                p2WebpageEditService.getEdit({ p2_webpage_keyno: p2WebpageKeyno }).then(function (info) {
                    angular.copy(info[0], vm.model.edit);
                });
            };

            // #endregion LOAD PROCEDURE CALL

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                p2WebpageEditService.saveObj(vm.model.edit).then(function () {
                    vm.model.lockedSave = false;

                    if (angular.isFunction(vm.onSave) && tabletSize.matches === true) {
                        vm.onSave();
                    } else {
                        stateService.back();
                    }
                }, function () {
                    vm.model.lockedSave = false;
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                //loadEdit();
            };

            // #endregion ON INIT FUNCTION

            // #region ON CHANGES FUNCTION

            vm.$onChanges = function (changes) {
                if (changes?.p2WebpageKeyno?.currentValue) {
                    p2WebpageKeyno = changes.p2WebpageKeyno.currentValue;
                }

                if (p2WebpageKeyno) loadEdit();
            };

            // #endregion ON CHANGES FUNCTION

        }]
    });
})();
